import React from 'react';
import Navigation from '../Shared/Navigation/Navigation';
import NewsAbout3 from './NewsAbout3/NewsAbout3';
import NewsBanner3 from './NewsBanner3/NewsBanner3';

const News3 = () => {
    return (
        <div>
            <Navigation></Navigation>
            <NewsBanner3></NewsBanner3>
             <NewsAbout3></NewsAbout3>
        </div>
    );
};

export default News3;